/** @jsxImportSource @emotion/react */

import Panels from 'src/components/Panel/Panels';
import ProjectionsListPanel from './ProjectionsListPanel';

export default function Projections() {
  return <Panels main={ProjectionsListPanel} />;
}
